"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelTariffCardMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _HotelTariffOffer = require("./HotelTariffOffer/HotelTariffOffer");
var _HotelRoomFacilities = _interopRequireDefault(require("../HotelRoomDescription/HotelRoomFacilities"));
var _MobileRoomGallery = _interopRequireDefault(require("../MobileRoomGallery"));
var _CashBack = _interopRequireDefault(require("../CashBack"));
var _Tab = _interopRequireDefault(require("../Tab"));
var _Tabs = _interopRequireDefault(require("../Tabs"));
var _HotelRoomName = _interopRequireWildcard(require("../HotelRoomDescription/HotelRoomName"));
var _LabelList = require("../Label/LabelList");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var YELLOW_TRIANGLE_HEIGHT = 8;
var YELLOW_TRIANGLE_OFFSET = 3;
var TABS = {
  price: {
    id: 'price',
    label: _localization.i18n.t('hotel.room.price'),
    width: 55
  },
  facilities: {
    id: 'facilities',
    label: _localization.i18n.t('hotel.room.facilities_mobile'),
    width: 135
  }
};
var HotelTariffCardMobile = exports.HotelTariffCardMobile = function HotelTariffCardMobile(_ref) {
  var onOfferClicked = _ref.onOfferClicked,
    bonusCount = _ref.bonusCount,
    cashbackIdentifier = _ref.cashbackIdentifier,
    customCashbackIconURL = _ref.customCashbackIconURL,
    customCashbackText = _ref.customCashbackText,
    customCashbackTooltipText = _ref.customCashbackTooltipText,
    area = _ref.area,
    hotelFacilities = _ref.hotelFacilities,
    labels = _ref.labels,
    mealTypes = _ref.mealTypes,
    tourists = _ref.tourists,
    room = _ref.room,
    offers = _ref.offers,
    onClickGallery = _ref.onClickGallery;
  var images = room.images,
    description = room.description,
    facilities = room.facilities,
    roomName = room.name_ru,
    originalName = room.name_en,
    idRoom = room.id;
  var _useState = (0, _react.useState)(TABS.price.id),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  var existRoomImages = roomImages.length !== 0;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHotelTariffCard, null, bonusCount ? /*#__PURE__*/_react["default"].createElement(AbsoluteCashback, {
    count: "+".concat(bonusCount),
    type: cashbackIdentifier,
    customCashbackIconURL: customCashbackIconURL,
    customCashbackText: customCashbackText,
    customCashbackTooltipText: customCashbackTooltipText,
    isMobile: true,
    cashbackText: true,
    existRoomImages: existRoomImages
  }) : null, roomImages ? /*#__PURE__*/_react["default"].createElement(StyledGallery, {
    onClickGallery: onClickGallery,
    images: roomImages,
    id: idRoom
  }) : null, /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledRoomName, {
    name: roomName,
    originalName: originalName,
    area: area
  }), /*#__PURE__*/_react["default"].createElement(StyldLabelList, {
    labels: labels,
    maxLabels: 6
  }), /*#__PURE__*/_react["default"].createElement(StyledTabs, {
    onChange: setSelectedTab
  }, Object.values(TABS).map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label,
      width = _ref2.width;
    return /*#__PURE__*/_react["default"].createElement(StyledTab, {
      key: id,
      value: id,
      selected: selectedTab === id,
      width: width
    }, label, selectedTab === id && /*#__PURE__*/_react["default"].createElement(StyledYellowTriangle, {
      width: width
    }));
  }))), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.price.id
  }, /*#__PURE__*/_react["default"].createElement(StyledTariffes, null, mealTypes.map(function (_ref3) {
    var id = _ref3.id,
      descriptionMeal = _ref3.description;
    var offersTariff = offers[id];
    return offersTariff ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDescriptionMeal, {
      key: "meal_".concat(descriptionMeal)
    }, descriptionMeal), /*#__PURE__*/_react["default"].createElement(StyledHotelOffers, null, offersTariff.map(function (offer, idxOffer) {
      var key = "".concat(idxOffer - offer.price);
      return /*#__PURE__*/_react["default"].createElement(_HotelTariffOffer.HotelTariffOffer, {
        key: key,
        tourists: tourists,
        onOfferClicked: onOfferClicked,
        offer: offer,
        isMobile: true
      });
    }))) : null;
  }))), /*#__PURE__*/_react["default"].createElement(StyledTabContent, {
    isVisible: selectedTab === TABS.facilities.id
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelRoomFacilities, {
    facilities: facilities,
    description: description,
    hotelFacilities: hotelFacilities,
    isMobile: true
  }))));
};
var StyledGallery = (0, _styledComponents["default"])(_MobileRoomGallery["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledGallery",
  componentId: "sc-19z440u-0"
})(["border-top-left-radius:4px;border-bottom-left-radius:4px;overflow:hidden;"]);
var AbsoluteCashback = (0, _styledComponents["default"])(_CashBack["default"]).withConfig({
  displayName: "HotelTariffCardMobile__AbsoluteCashback",
  componentId: "sc-19z440u-1"
})(["", ";"], function (_ref4) {
  var existRoomImages = _ref4.existRoomImages;
  return existRoomImages && "\n      position: absolute;\n      z-index: 2;\n      left: 9px;\n      top: 9px;\n    ";
});
var StyledHotelTariffCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledHotelTariffCard",
  componentId: "sc-19z440u-2"
})(["width:100%;padding:2px;border-radius:4px;background:white;position:relative;"]);
var StyledDescriptionMeal = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledDescriptionMeal",
  componentId: "sc-19z440u-3"
})(["font-size:18px;padding:8px;line-height:22px;font-weight:700;"]);
var StyledHotelOffers = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledHotelOffers",
  componentId: "sc-19z440u-4"
})(["> div{border-top:0.5px solid #c2c5cc;}"]);
var StyledTariffes = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledTariffes",
  componentId: "sc-19z440u-5"
})(["display:flex;flex-direction:column;> ", ":not(:first-child){border-top:0.5px solid #c2c5cc;}"], StyledDescriptionMeal);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledWrapper",
  componentId: "sc-19z440u-6"
})(["margin-top:6px;margin-left:10px;"]);
var StyledRoomName = (0, _styledComponents["default"])(_HotelRoomName["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledRoomName",
  componentId: "sc-19z440u-7"
})(["", "{font-size:11px;}"], _HotelRoomName.StyledSubtext);
var StyldLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelTariffCardMobile__StyldLabelList",
  componentId: "sc-19z440u-8"
})(["margin-top:8px;"]);
var StyledTabs = (0, _styledComponents["default"])(_Tabs["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelTariffCardMobile__StyledTabs",
  componentId: "sc-19z440u-9"
})(["display:flex;margin:10px 0;"]);
var StyledTab = (0, _styledComponents["default"])(_Tab["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledTab",
  componentId: "sc-19z440u-10"
})(["font-size:13px;font-weight:", ";color:", ";height:35px;width:", ";position:relative;", ";button{position:relative;z-index:1;padding-bottom:10px;}"], function (props) {
  return props.selected ? 'bold' : 'normal';
}, function (props) {
  return props.selected ? props.theme.colors.blackBase : props.theme.colors.blackLight;
}, function (_ref5) {
  var width = _ref5.width;
  return "".concat(width, "px");
}, function (_ref6) {
  var theme = _ref6.theme,
    selected = _ref6.selected;
  return selected && "\n      ::before {\n        content: '';\n        position: absolute;\n        background-color: ".concat(theme.colors.yellowBase, ";\n        left: 0;\n        bottom: ").concat(YELLOW_TRIANGLE_HEIGHT, "px;\n        top: 0;\n        right: 0;\n        z-index: 1;\n        border-radius: ").concat(theme.shape.borderRadius, ";\n      }\n    ");
});
var StyledYellowTriangle = _styledComponents["default"].i.withConfig({
  displayName: "HotelTariffCardMobile__StyledYellowTriangle",
  componentId: "sc-19z440u-11"
})(["position:absolute;width:0;height:0;z-index:1;left:", "px;bottom:0;border-top:", "px solid ", ";border-left:", ";border-right:", ";"], YELLOW_TRIANGLE_OFFSET, YELLOW_TRIANGLE_HEIGHT, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.yellowBase;
}, function (_ref8) {
  var width = _ref8.width,
    theme = _ref8.theme;
  return "".concat(width / 2 - YELLOW_TRIANGLE_OFFSET, "px solid ").concat(theme.colors.white);
}, function (_ref9) {
  var width = _ref9.width,
    theme = _ref9.theme;
  return "".concat(width / 2 - YELLOW_TRIANGLE_OFFSET, "px solid ").concat(theme.colors.white);
});
var StyledTabContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffCardMobile__StyledTabContent",
  componentId: "sc-19z440u-12"
})(["display:", ";"], function (_ref10) {
  var isVisible = _ref10.isVisible;
  return isVisible ? 'block' : 'none';
});
var StyledHotelRoomFacilities = (0, _styledComponents["default"])(_HotelRoomFacilities["default"]).withConfig({
  displayName: "HotelTariffCardMobile__StyledHotelRoomFacilities",
  componentId: "sc-19z440u-13"
})(["margin:10px;"]);